export default "__VITE_ASSET__mn7FrA6___"